module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/shared/main/vehicle/vehicle-list/vehicle-list.component.css
// module id = ./src/app/components/calculator/calculator-item/shared/main/vehicle/vehicle-list/vehicle-list.component.css
// module chunks = main